import { Img } from '~/components/elements/Img'

type Props = {
  href: string
  name: string
  category: string
  brand: {
    name: string
    kana: string
  }
  price?: string
  size?: string
  imageUrl: string
  imageAlt: string
  onLinkClick?: () => void
}

export const ItemFooter: React.FC<Props> = ({
  onLinkClick,
  href,
  imageAlt,
  imageUrl,
  brand,
  price,
  size,
  category,
}) => (
  <div className="flex items-center gap-2 bg-white px-[10px] py-[9px]">
    <a
      onClick={onLinkClick}
      href={href}
      className="flex shrink-0 hover:opacity-70"
    >
      {imageUrl ? (
        <Img src={imageUrl} alt={imageAlt} width={40} height={48} />
      ) : (
        <div className="h-12 w-10" />
      )}
    </a>
    <div className="flex flex-col gap-[6px] overflow-hidden">
      <a
        onClick={onLinkClick}
        href={href}
        className="truncate text-[13px] leading-[1.2] text-black-400 hover:opacity-70"
      >
        {brand.name}
      </a>
      <p className="truncate text-[14px] leading-none text-gray-600">
        {price && size ? `${price} / size:${size}` : category}
      </p>
    </div>
  </div>
)
